import { render, staticRenderFns } from "./ac-collection-grouped-card.vue?vue&type=template&id=58ddd3dd&"
import script from "./ac-collection-grouped-card.vue?vue&type=script&lang=js&"
export * from "./ac-collection-grouped-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports